import { CreateUpdateFleetRequest } from '@src/main/modules/parameters/infrastructure/dto/createUpdateFleetRequest';
import { createFleetHttpRepository } from '@src/main/modules/parameters/infrastructure/repository/FleetHttpRepository';
import { TokenProvider } from '@src/main/shared/infrastructure/entity/axios';

export const updateFleetUseCase = async (
  id: string,
  data: CreateUpdateFleetRequest,
  tokenProvider: TokenProvider,
) => {
  const repository = createFleetHttpRepository(tokenProvider);
  return await repository.update(id, data);
};
